module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "quillEditorQiniu"
    }
  }, [_c('quill-editor', {
    ref: "customQuillEditor",
    staticClass: "editor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67c44df5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/squill-editor-qiniu.vue
// module id = 1852
// module chunks = 2